// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__JDXkU","header":"MergedInvoice_header__1gph3"};